import React, { useEffect } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { FaLink, FaUserFriends } from 'react-icons/fa';
import { RiDashboardFill } from 'react-icons/ri'
import { useAuthContext } from '../contexts/AuthContext'; // Import the useAuthContext hook
import './Dashboard.css'; // Import the CSS file
import Header from '../components/Header';

const Dashboard = () => {
  const { logout } = useAuthContext(); // Access the logout function from the context

  const handleLogout = () => {
    logout();
    // Redirect to login page after logout
    return <Navigate to="/login" />;
  };

  useEffect(() => {
    console.log('Dashboard Page Rendered');
    console.log('Body Element:', document.body);
    console.log('HTML Element:', document.documentElement);
    // Add more logs or checks as needed
  }, []);

  const tiles = [
    { id: 1, title: 'HGV Links', icon: <FaLink />, link: '/sites' },
    { id: 2, title: 'EQA Dashboard', icon: <RiDashboardFill />, link: '/eqa-dashboard' },
    { id: 3, title: 'Bomgar Users', icon: <FaUserFriends />, link: '/bomgar' },
    // Add more tiles as needed
  ];

  return (
    <div className="container">
      <div className="header">
        <Header />
      </div>
      <div className="tile-container">
        {tiles.map((tile) => (
          <Link key={tile.id} to={tile.link} className="tile" onClick={tile.onClick}>
            <div className="icon">{tile.icon}</div>
            <span>{tile.title}</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
